"use strict";

exports.__esModule = true;
exports.ProfileDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _icons = require("@blueprintjs/icons");
var _Form = require("../../Form");
var _Translator = require("../../Core/Translator");
var _ProfileContext = require("../ProfileContext/ProfileContext");
var _Heading = require("../../Core/Heading");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Right = _styledComponents["default"].div.withConfig({
  displayName: "ProfileDialog__Right",
  componentId: "sc-fb7xd6-0"
})(["display:flex;flex-direction:row-reverse;button{margin-left:5px;}"]);
var Input = function Input(_ref) {
  var id = _ref.id,
    defaultName = _ref.defaultName,
    name = _ref.name,
    disabled = _ref.disabled;
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  var translated = translate(id, defaultName);
  var validate = function validate(value) {
    if (value === void 0) {
      value = "";
    }
    if (value.length > 0) {
      return undefined;
    }
    return translated + " field is Required";
  };
  return /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
    name: name,
    label: translated,
    validate: validate
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
      disabled: disabled
    }, input, {
      type: "text",
      "data-testid": name,
      placeholder: translated
    })), meta.error ? meta.error.message : null);
  });
};
var onSubmit = function onSubmit(updateCurrentUser, user, onClose) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return updateCurrentUser(user.id, Object.assign({}, user, {
              profile: {
                name: {
                  first: values.firstName,
                  last: values.lastName
                },
                email: values.email
              },
              password: values.password
            }));
          case 1:
            onClose();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var ProfileDialog = exports.ProfileDialog = function ProfileDialog(_ref4) {
  var placeholder = _ref4.placeholder,
    isOpen = _ref4.isOpen,
    onClose = _ref4.onClose;
  var _useState = (0, _react.useState)(false),
    isEditing = _useState[0],
    setEditing = _useState[1];
  var onEditClick = (0, _react.useCallback)(function () {
    return setEditing(true);
  });
  var onCloseClick = (0, _react.useCallback)(function () {
    setEditing(false);
    onClose();
  });

  // $FlowFixMe
  var profile = (0, _react.useContext)(_ProfileContext.ProfileContext);
  var fetching = profile.fetching,
    user = profile.user,
    updateCurrentUser = profile.updateCurrentUser;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var translator = (0, _react.useContext)(_Translator.TranslatorContext);
  var translate = translator.translate;
  if (fetching) {
    return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
      className: theme.bodyClassName,
      isOpen: isOpen,
      onClose: onCloseClick
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_BODY,
      "data-testid": "spinner"
    }, /*#__PURE__*/_react["default"].createElement(_Core.Spinner, {
      key: "loading",
      className: _core.Classes.BUTTON_SPINNER,
      size: _core.IconSize.LARGE
    })));
  }
  var _ref5 = user.profile || {
      name: {
        first: "",
        last: ""
      },
      email: ""
    },
    name = _ref5.name,
    email = _ref5.email;
  var _ref6 = name || {},
    first = _ref6.first,
    last = _ref6.last;
  var initialValues = {
    firstName: first,
    lastName: last,
    email: email
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    className: theme.bodyClassName,
    isOpen: isOpen,
    onClose: onCloseClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_HEADER
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.USER,
    size: 24
  }), /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
    level: 5
  }, placeholder)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY,
    "data-testid": "profile-dialog"
  }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    onSubmit: onSubmit(updateCurrentUser, user, onClose),
    initialValues: initialValues,
    render: function render(_ref7) {
      var handleSubmit = _ref7.handleSubmit,
        values = _ref7.values;
      return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, translator.intl, /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(Input, {
        id: "Profile.user.first",
        name: "firstName",
        defaultName: "First Name",
        disabled: !isEditing
      }), /*#__PURE__*/_react["default"].createElement(Input, {
        id: "Profile.user.last",
        name: "lastName",
        defaultName: "Last Name",
        disabled: !isEditing
      }), /*#__PURE__*/_react["default"].createElement(_Form.EmailEditor, {
        disabled: !isEditing
      }), /*#__PURE__*/_react["default"].createElement(_core.Label, {
        style: {
          fontWeight: "bold",
          marginBottom: "10px"
        }
      }, translate("ProfileDialog.ChangePassword", "Change password")), /*#__PURE__*/_react["default"].createElement(_Form.PasswordEditor, {
        id: "password",
        allowEmptyPassword: true,
        disabled: !isEditing
      }), /*#__PURE__*/_react["default"].createElement(Right, null, !isEditing ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
        intent: _core.Intent.PRIMARY,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "Profile.ProfileDialog.Button.Edit",
          defaultMessage: "Edit"
        }),
        onClick: onEditClick
      }) : null, isEditing ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
        intent: _core.Intent.PRIMARY,
        disabled: (0, _reactFastCompare["default"])(initialValues, values),
        type: "submit",
        "data-testid": "save",
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "Profile.ProfileDialog.Button.Save",
          defaultMessage: "Save"
        })
      }) : null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "Profile.ProfileDialog.Button.Close",
          defaultMessage: "Close"
        }),
        onClick: onCloseClick
      }))));
    }
  })));
};